// extracted by mini-css-extract-plugin
export var activeDot = "_7t-c";
export var buttonContainer = "_7t-9";
export var channelButton = "_7t-a";
export var clickable = "_7t-d";
export var content = "_7t-0";
export var contentFull = "_7t-2";
export var contentThird = "_7t-1";
export var contentWrapper = "_7t-7";
export var description = "_7t-5";
export var heightShort = "_7t-f";
export var image = "_7t-3";
export var imageContainer = "_7t-4";
export var selectButton = "_7t-e";
export var spinnerContainer = "_7t-b";
export var titleContent = "_7t-8";
export var titleWrapper = "_7t-6";